/*@flow*/
import useCachedQuery from 'lib/useCachedQuery';
import GetCommunitySettings from './Dashboard/queries/GetCommunitySettings';
import * as I from 'immutable';
import { useEffect, useState } from 'react';

// Fetch the primary color from the company's community settings.
export default function useThemeColor(): any {
  const [, setState] = useState();
  const [isLoading, setLoading] = useState(true);

  // TODO: fetch current community info and use its company_id.
  const companyId = window.companyId;
  const skip = !companyId;
  const variables = { id: companyId };
  const opts = { variables, skip };
  const { data, ...rest } = useCachedQuery(GetCommunitySettings, opts);
  const color = 'var(--info)';
  const path = ['company', 'communitySettings', 'primaryColor'];
  const data2 = I.getIn(data, path, color) || color;

  // Try until companyId is loaded.
  useEffect(() => {
    if (!companyId) {
      setTimeout(() => setState(Math.random()), 100);
    }
  }, [companyId]);

  // When loading is finished, set the local state flag to false.
  useEffect(() => {
    if (rest.loading) return;
    setLoading(false);
  }, [rest.loading]);

  return { ...rest, data: data2, loading: isLoading };
}
